import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 64px;
  padding: 0 16px;

  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
